module.exports = __webpack_public_path__ + "media/images/illustrations/flat_fogg_welcome-26e2abeac410b37f0bff20c38e1f10d1.png";